import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { enumPaymentRequestState } from '../enums/payments';
import { PaginatedResultModel } from '@data-layer/models/common';
import { ManagementPaymentRequestModel, ManagementPaymentRequestSearchModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class PaymentRequestsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: ManagementPaymentRequestSearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementPaymentRequestModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementPaymentRequestModel>>(
      `${environment.url.prefixCustoms}v2/management/payment-requests`,
      {
        params,
      },
      { isShowLoader },
    );
  }

  public get(id: ManagementPaymentRequestModel['id'], isShowLoader: boolean = true): Observable<ManagementPaymentRequestModel> {
    return this.apiService.get<ManagementPaymentRequestModel>(
      `${environment.url.prefixCustoms}v2/management/payment-requests/${id}`,
      null,
      { isShowLoader },
    );
  }

  public setState(id: ManagementPaymentRequestModel['id'], state: enumPaymentRequestState, isShowLoader: boolean = true): Observable<any> {
    return this.apiService.put<any>(`${environment.url.prefixCustoms}v2/management/payment-requests/${id}/state`, state, null, {
      isShowLoader,
    });
  }
}
